import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-732debe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = { class: "footer-copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_footer_content_view = _resolveComponent("footer-content-view")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentList, (item, index) => {
        return (_openBlock(), _createBlock(_component_footer_content_view, {
          src: item.img,
          title: item.title,
          content: item.content,
          key: index
        }, null, 8, ["src", "title", "content"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, " Copyright © " + _toDisplayString(_ctx.year) + "版权所有 ", 1)
  ]))
}